import '../game.css';

const React = require('react');
const PorinBoxComponent = require('./porinBoxComponent').default;
const PlayerComponent = require('./playerComponent').default;
// ============================

const renderPorinBox = (select, frameId) => {
    return (
        <PorinBoxComponent
            type={select.type}
            porins={select.porins}
            rotate={select.rotate}
            frameId={frameId} />
    )
}

export default class selectorComponent extends React.Component {
    render() {
        const { selectorState, playerState, skillRemainingTime } = this.props;
        return (
            <div className="selector">
                <div className="selector-slot" onClick={() => this.props.onClickSelector(0)}>
                    <div className="selector-slot-object">
                        <div>
                            {renderPorinBox(selectorState.selector[0], 0)}
                        </div>
                    </div>
                    <div className="selector-slot-mark">
                        ▼
                    </div>
                </div>

                <div className="selector-slot" onClick={() => this.props.onClickSelector(1)}>
                    <div className="selector-slot-object">
                        <div>
                            {renderPorinBox(selectorState.selector[1], 1)}
                        </div>
                    </div>
                    <div className="selector-slot-mark">
                        ▼
                    </div>
                </div>

                <div className="selector-slot" onClick={() => this.props.onClickSelector(2)}>
                    <div className="selector-slot-object">
                        <div>
                            {renderPorinBox(selectorState.selector[2], 2)}
                        </div>
                    </div>
                    <div className="selector-slot-mark">
                        ▼
                    </div>
                </div>

                <div className="selector-slot">
                    <div className="selector-slot-object">
                        <PlayerComponent state={playerState} skillRemainingTime={skillRemainingTime} />
                    </div>
                    <div className="selector-slot-mark">
                        ▼
                    </div>
                </div>
            </div>
        )
    }
}
